import { AdminTab, PlatformAdmin } from '../types'

interface Props {
  activeTab: AdminTab
  onSelectTab: (tab: AdminTab) => void
  admin: PlatformAdmin | null
  onLogout: () => void
  counts: {
    tenants: number
    platformAdmins: number
    tenantAdmins: number
  }
}

export function Sidebar({
  activeTab,
  onSelectTab,
  admin,
  onLogout,
  counts,
}: Props) {
  const adminInitials = admin?.full_name
    ? admin.full_name
        .split(' ')
        .map((n) => n[0])
        .join('')
        .toUpperCase()
        .slice(0, 2)
    : admin?.email
    ? admin.email.slice(0, 2).toUpperCase()
    : 'PA'

  return (
    <aside className="app-sidebar" aria-label="Platform Admin Menüsü">
      {/* Platform Brand Block */}
      <div className="sidebar-brand-block">
        <div className="brand-icon-wrapper" aria-hidden="true">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="3" width="7" height="7" rx="1" />
            <rect x="14" y="3" width="7" height="7" rx="1" />
            <rect x="14" y="14" width="7" height="7" rx="1" />
            <rect x="3" y="14" width="7" height="7" rx="1" />
          </svg>
        </div>
        <div className="brand-text-wrapper">
          <span className="brand-name">Cost ERP Platform</span>
          <div className="tenant-status-row">
            <span className="tenant-display-name">Superadmin Portal</span>
          </div>
        </div>
      </div>

      {/* Navigation Sections */}
      <nav className="sidebar-nav">
        <div className="nav-group">
          <div className="nav-group-title">Sistem & İzleme</div>
          <button
            type="button"
            className={`nav-item ${activeTab === 'overview' ? 'active' : ''}`}
            onClick={() => onSelectTab('overview')}
          >
            <span className="nav-icon" aria-hidden="true">
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="20" x2="18" y2="10" />
                <line x1="12" y1="20" x2="12" y2="4" />
                <line x1="6" y1="20" x2="6" y2="14" />
              </svg>
            </span>
            <span className="nav-label">Genel Bakış</span>
          </button>
        </div>

        <div className="nav-group">
          <div className="nav-group-title">Organizasyon Yönetimi</div>
          <button
            type="button"
            className={`nav-item ${activeTab === 'tenants' ? 'active' : ''}`}
            onClick={() => onSelectTab('tenants')}
          >
            <span className="nav-icon" aria-hidden="true">
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M3 21h18" />
                <path d="M5 21V7l8-4v18" />
                <path d="M19 21V11l-6-3" />
                <path d="M9 9h1" />
                <path d="M9 13h1" />
                <path d="M9 17h1" />
              </svg>
            </span>
            <span className="nav-label">Tenant Yönetimi</span>
            <span className="nav-count">{counts.tenants}</span>
          </button>

          <button
            type="button"
            className={`nav-item ${activeTab === 'tenant-admins' ? 'active' : ''}`}
            onClick={() => onSelectTab('tenant-admins')}
          >
            <span className="nav-icon" aria-hidden="true">
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
            </span>
            <span className="nav-label">Tenant Yöneticileri</span>
            <span className="nav-count">{counts.tenantAdmins}</span>
          </button>
        </div>

        <div className="nav-group">
          <div className="nav-group-title">Platform Güvenliği</div>
          <button
            type="button"
            className={`nav-item ${activeTab === 'platform-admins' ? 'active' : ''}`}
            onClick={() => onSelectTab('platform-admins')}
          >
            <span className="nav-icon" aria-hidden="true">
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
              </svg>
            </span>
            <span className="nav-label">Platform Yöneticileri</span>
            <span className="nav-count">{counts.platformAdmins}</span>
          </button>
        </div>
      </nav>

      {/* Footer / Profile */}
      <div className="sidebar-footer">
        <div className="user-profile-summary">
          <div className="user-avatar" title={admin?.email || 'Platform Admin'}>
            {adminInitials}
          </div>
          <div className="user-info-text">
            <span className="user-name-label">{admin?.full_name || 'Platform Admin'}</span>
            <span className="user-role-label">Superadmin</span>
          </div>
        </div>
        <button
          type="button"
          className="btn-logout"
          onClick={onLogout}
          title="Güvenli Çıkış Yap"
        >
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <polyline points="16 17 21 12 16 7" />
            <line x1="21" y1="12" x2="9" y2="12" />
          </svg>
        </button>
      </div>
    </aside>
  )
}
